import { createReducer, on, createFeatureSelector, createSelector } from '@ngrx/store';
import { resetCandidates, setCandidates } from '../actions/candidates.actions';
import { Pagination } from '../models/pagination.model';
import { Candidate } from '../models/candidate.model';

export const initialState: Pagination<Candidate> = null;

const reducer = createReducer(initialState,
  on(setCandidates, (state, candidates) => candidates),
  on(resetCandidates, () => initialState),
);

export const fromCandidates = {
  selectCandidatesState: createFeatureSelector<Pagination<Candidate>>('candidates'),
};

export function candidatesReducer(state, action) {
  return reducer(state, action);
}
